/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_DeletingInputs */



/**
* | output |
* | --- |
* | "Deleting..." |
*
* @param {Member_DeletingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const member_deleting = /** @type {((inputs?: Member_DeletingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_DeletingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suppression...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Excluindo...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eliminazione...")
	return /** @type {LocalizedString} */ ("Deleting...")
});